import React from "react";
import "./App.css";
import { Admin, Resource } from "react-admin";
import theme from "./theme";
import layout from "./layout";

import Login from "./pages/Login";
import DomainIcon from "@material-ui/icons/Domain";
import ZoneOnIcon from "@material-ui/icons/LocationOn";
import PeopleIcon from "@material-ui/icons/People";
import ContactPhoneIcon from "@material-ui/icons/ContactPhone";
import DispatchTabletIcon from "@material-ui/icons/Tablet";
import VideocamIcon from "@material-ui/icons/Videocam";

import DispatchTabletList from "./pages/DispatchTablet/List";
import DispatchTabletShow from "./pages/DispatchTablet/Show";
import DispatchTabletEdit from "./pages/DispatchTablet/Edit";

import UserList from "./pages/User/List";
import UserCreate from "./pages/User/Create";
import UserShow from "./pages/User/Show";
import UserEdit from "./pages/User/Edit";

import FormShow from "./pages/Forms/Show";
import MarketingShow from "./pages/Marketing/Show";
import VideoShow from "./pages/Videos/Show";

import OrganizationList from "./pages/Organization/List";
import OrganizationCreate from "./pages/Organization/Create";
import OrganizationShow from "./pages/Organization/Show";
import OrganizationEdit from "./pages/Organization/Edit";

import ZoneList from "./pages/Zone/List";
import ZoneCreate from "./pages/Zone/Create";
import ZoneShow from "./pages/Zone/Show";
import ZoneEdit from "./pages/Zone/Edit";

import ContactListList from "./pages/ContactList/List";
import ContactListCreate from "./pages/ContactList/Create";
import ContactListShow from "./pages/ContactList/Show";
import ContactListEdit from "./pages/ContactList/Edit";

import ContactList from "./pages/Contact/List";
import ContactCreate from "./pages/Contact/Create";
import ContactShow from "./pages/Contact/Show";
import ContactEdit from "./pages/Contact/Edit";

import WebhookList from "./pages/Webhook/List";
import WebhookCreate from "./pages/Webhook/Create";
import WebhookShow from "./pages/Webhook/Show";
import WebhookEdit from "./pages/Webhook/Edit";

import WebhookEventShow from "./pages/WebhookEvents/Show";

import PanelEventShow from "./pages/PanelEvents/Show";

import CameraList from "./pages/Camera/List";
import CameraCreate from "./pages/Camera/Create";
import CameraShow from "./pages/Camera/Show";
import CameraEdit from "./pages/Camera/Edit";

import PanelList from "./pages/Panel/List";
import PanelCreate from "./pages/Panel/Create";
import PanelShow from "./pages/Panel/Show";
import PanelEdit from "./pages/Panel/Edit";

import AlertTypeList from "./pages/AlertTypes/List";

import PendantList from "./pages/Pendant/List";
import PendantCreate from "./pages/Pendant/Create";
import PendantShow from "./pages/Pendant/Show";
import PendantEdit from "./pages/Pendant/Edit";

import Dashboard from "./pages/Dashboard";

import DataProvider from "./DataProvider";

const createHistory = require("history").createBrowserHistory;
const history = createHistory();

const authProvider = {
  login: (params) => Promise.resolve(),

  logout: async (params) => {
    console.log("Logging out");
    await fetch("/api/logout", { method: "POST" });
    return Promise.resolve();
  },

  checkAuth: async (params) => {
    console.log("Checking Auth");
    const response = await fetch("/api/check-auth", { method: "POST" });
    if (!response.ok) {
      console.log("Not Authorized");
      throw new Error("Not Authorized"); // Throwing an error for clarity
    }
  },

  checkError: (error) => {
    const { status } = error;
    if (status === 401 || status === 403) {
      return Promise.reject();
    }
    return Promise.resolve();
  },

  getPermissions: async (params) => {
    const response = await fetch("/api/check-role", { method: "POST" });
    if (!response.ok) {
      throw new Error("Role check failed"); // Handle non-OK responses explicitly
    }
    const data = await response.json();
    return data.role; // Directly return the role
  },
};

export default () => {
  //Redirect from http to https
  const location = window.location;
  if (
    location.protocol === "http:" &&
    location.hostname !== "localhost" &&
    location.hostname !== "127.0.0.1"
  ) {
    location.replace(
      `https:${location.href.substring(location.protocol.length)}`
    );
  }

  return (
    <Admin
      history={history}
      authProvider={authProvider}
      dataProvider={DataProvider}
      dashboard={Dashboard}
      loginPage={Login}
      title="SOS Technologies"
      theme={theme}
      layout={layout}
    >
      {(permissions) => [
        permissions === "super-admin" || permissions === "channel-admin" ? (
          <Resource
            name="organizations"
            icon={DomainIcon}
            list={OrganizationList}
            create={OrganizationCreate}
            show={OrganizationShow}
            edit={OrganizationEdit}
          />
        ) : null,
        // permissions === 'super-admin'
        //   || permissions === 'channel-admin'
        //   ? <Resource name="Forms" options={{ label: 'Forms' }} icon={DomainIcon} list={FormShow} create={FormShow} show={FormShow} edit={FormShow} />
        //   : null,
        permissions === "super-admin" || permissions === "channel-admin" ? (
          <Resource
            name="Videos"
            options={{ label: "Videos" }}
            icon={DomainIcon}
            list={VideoShow}
            create={VideoShow}
            show={VideoShow}
            edit={VideoShow}
          />
        ) : null,
        permissions === "super-admin" || permissions === "channel-admin" ? (
          <Resource
            name="Marketing"
            options={{ label: "Marketing" }}
            icon={DomainIcon}
            list={MarketingShow}
            create={MarketingShow}
            show={MarketingShow}
            edit={MarketingShow}
          />
        ) : null,
        permissions === "super-admin" || permissions === "channel-admin" ? (
          <Resource
            name="zones"
            icon={ZoneOnIcon}
            list={ZoneList}
            create={ZoneCreate}
            show={ZoneShow}
            edit={ZoneEdit}
          />
        ) : null,
        permissions === "super-admin" || permissions === "channel-admin" ? (
          <Resource
            name="dispatch-tablets"
            options={{ label: "Dispatch Consoles" }}
            icon={DispatchTabletIcon}
            list={DispatchTabletList}
            show={DispatchTabletShow}
            edit={DispatchTabletEdit}
          />
        ) : null,
        permissions === "super-admin" ? (
          <Resource
            name="panels"
            icon={PanelList}
            list={PanelList}
            create={PanelCreate}
            show={PanelShow}
            edit={PanelEdit}
          />
        ) : null,
        permissions === "super-admin" ? (
          <Resource
            name="pendants"
            icon={PanelList}
            list={PendantList}
            create={PendantCreate}
            show={PendantShow}
            edit={PendantEdit}
          />
        ) : null,
        permissions === "super-admin" ? (
          <Resource name="alert-types" list={AlertTypeList} />
        ) : null,
        permissions === "super-admin" ? (
          <Resource
            name="cameras"
            icon={VideocamIcon}
            list={CameraList}
            create={CameraCreate}
            show={CameraShow}
            edit={CameraEdit}
          />
        ) : null,
        <Resource
          name="contactlists"
          options={{ label: "Contact Lists" }}
          list={ContactListList}
          create={ContactListCreate}
          show={ContactListShow}
          edit={ContactListEdit}
        />,

        permissions === "super-admin" ? (
          <Resource
            name="webhooks"
            options={{ label: "Webhooks" }}
            list={WebhookList}
            create={WebhookCreate}
            show={WebhookShow}
            edit={WebhookEdit}
          />
        ) : null,

        permissions === "super-admin" ? (
          <Resource
            name="webhookevents"
            options={{ label: "Webhook Events" }}
            show={WebhookEventShow}
          />
        ) : null,

        permissions === "super-admin" ? (
          <Resource
            name="panelevents"
            options={{ label: "Panel Events" }}
            show={PanelEventShow}
          />
        ) : null,
        <Resource
          name="contacts"
          icon={ContactPhoneIcon}
          options={{ label: "Contacts" }}
          list={ContactList}
          create={ContactCreate}
          show={ContactShow}
          edit={ContactEdit}
        />,
        permissions === "super-admin" || permissions === "channel-admin" ? (
          <Resource
            name="users"
            icon={PeopleIcon}
            list={UserList}
            create={UserCreate}
            show={UserShow}
            edit={UserEdit}
          />
        ) : null,
        permissions === "org-admin" ? (
          <Resource
            name="users"
            options={{ label: "Account Settings" }}
            icon={PeopleIcon}
            list={UserList}
            show={UserShow}
            edit={UserEdit}
          />
        ) : null,
        permissions === "super-admin" ||
        permissions === "channel-admin" ? null : (
          <Resource name="organizations" />
        ), // this must be here for the <ReferencesInput /> to work. Read the docs.
      ]}
    </Admin>
  );
};
